import script from "./AppV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppV2.vue?vue&type=script&setup=true&lang=ts"

import "./AppV2.vue?vue&type=style&index=0&id=50f03772&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f03772"]])

export default __exports__